import Cookies from 'js-cookie';

const COOKIE_NAME = 'three_letter_code';

export const getThreeLetterCode = () => Cookies.get(COOKIE_NAME);
export const setThreeLetterCode = (threeLetterCode: string) =>
  Cookies.set(COOKIE_NAME, threeLetterCode);
export const removeThreeLetterCode = () => Cookies.remove(COOKIE_NAME);
